import { render } from "./ReportSidebar.vue?vue&type=template&id=2f11f8e3&scoped=true"
import script from "./ReportSidebar.vue?vue&type=script&lang=js"
export * from "./ReportSidebar.vue?vue&type=script&lang=js"

import "./ReportSidebar.vue?vue&type=style&index=0&id=2f11f8e3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f11f8e3"]])

export default __exports__